export type IconsId =
  | 'zoom'
  | 'zoom-out'
  | 'zoom-in'
  | 'youtube'
  | 'wishlist'
  | 'wishlist-fill'
  | 'wings'
  | 'twitter'
  | 'tshirt'
  | 'trousers'
  | 'tick'
  | 'symbol-list'
  | 'stockist'
  | 'star'
  | 'star-empty'
  | 'shoes'
  | 'share'
  | 'share-1'
  | 'search'
  | 'saddle'
  | 'saddle-pad'
  | 'rugs'
  | 'return'
  | 'rate-half'
  | 'rate-full'
  | 'rate-empty'
  | 'print'
  | 'plus'
  | 'plus-2'
  | 'pinterest'
  | 'phone'
  | 'phone-inline'
  | 'notification'
  | 'minus'
  | 'menu'
  | 'martingales'
  | 'longsleeve'
  | 'logout'
  | 'lock'
  | 'location'
  | 'linkedin'
  | 'instagram'
  | 'i'
  | 'hoodie'
  | 'home'
  | 'helmet'
  | 'headcollars'
  | 'grooming'
  | 'grid-4'
  | 'grid-3'
  | 'grid-2'
  | 'grid-1'
  | 'gloves'
  | 'gift'
  | 'full-arrow'
  | 'flyhood'
  | 'faqs'
  | 'facebook'
  | 'email'
  | 'edit'
  | 'earth'
  | 'download'
  | 'delivery'
  | 'credit-cards'
  | 'copy'
  | 'contact'
  | 'contact-us'
  | 'coat'
  | 'close'
  | 'clock'
  | 'chevron2-right'
  | 'chevron2-left'
  | 'chevron'
  | 'chevron-right'
  | 'chevron-left'
  | 'chat'
  | 'card'
  | 'call'
  | 'bridle'
  | 'basket'
  | 'basket-add'
  | 'arrow-up'
  | 'arrow-simple-left'
  | 'arrow-right'
  | 'arrow-right-bold'
  | 'arrow-left'
  | 'arrow-down'
  | 'address-book'
  | 'account';

export type IconsKey =
  | 'Zoom'
  | 'ZoomOut'
  | 'ZoomIn'
  | 'Youtube'
  | 'Wishlist'
  | 'WishlistFill'
  | 'Wings'
  | 'Twitter'
  | 'Tshirt'
  | 'Trousers'
  | 'Tick'
  | 'SymbolList'
  | 'Stockist'
  | 'Star'
  | 'StarEmpty'
  | 'Shoes'
  | 'Share'
  | 'Share1'
  | 'Search'
  | 'Saddle'
  | 'SaddlePad'
  | 'Rugs'
  | 'Return'
  | 'RateHalf'
  | 'RateFull'
  | 'RateEmpty'
  | 'Print'
  | 'Plus'
  | 'Plus2'
  | 'Pinterest'
  | 'Phone'
  | 'PhoneInline'
  | 'Notification'
  | 'Minus'
  | 'Menu'
  | 'Martingales'
  | 'Longsleeve'
  | 'Logout'
  | 'Lock'
  | 'Location'
  | 'Linkedin'
  | 'Instagram'
  | 'I'
  | 'Hoodie'
  | 'Home'
  | 'Helmet'
  | 'Headcollars'
  | 'Grooming'
  | 'Grid4'
  | 'Grid3'
  | 'Grid2'
  | 'Grid1'
  | 'Gloves'
  | 'Gift'
  | 'FullArrow'
  | 'Flyhood'
  | 'Faqs'
  | 'Facebook'
  | 'Email'
  | 'Edit'
  | 'Earth'
  | 'Download'
  | 'Delivery'
  | 'CreditCards'
  | 'Copy'
  | 'Contact'
  | 'ContactUs'
  | 'Coat'
  | 'Close'
  | 'Clock'
  | 'Chevron2Right'
  | 'Chevron2Left'
  | 'Chevron'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'Chat'
  | 'Card'
  | 'Call'
  | 'Bridle'
  | 'Basket'
  | 'BasketAdd'
  | 'ArrowUp'
  | 'ArrowSimpleLeft'
  | 'ArrowRight'
  | 'ArrowRightBold'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'AddressBook'
  | 'Account';

export enum Icons {
  Zoom = 'zoom',
  ZoomOut = 'zoom-out',
  ZoomIn = 'zoom-in',
  Youtube = 'youtube',
  Wishlist = 'wishlist',
  WishlistFill = 'wishlist-fill',
  Wings = 'wings',
  Twitter = 'twitter',
  Tshirt = 'tshirt',
  Trousers = 'trousers',
  Tick = 'tick',
  SymbolList = 'symbol-list',
  Stockist = 'stockist',
  Star = 'star',
  StarEmpty = 'star-empty',
  Shoes = 'shoes',
  Share = 'share',
  Share1 = 'share-1',
  Search = 'search',
  Saddle = 'saddle',
  SaddlePad = 'saddle-pad',
  Rugs = 'rugs',
  Return = 'return',
  RateHalf = 'rate-half',
  RateFull = 'rate-full',
  RateEmpty = 'rate-empty',
  Print = 'print',
  Plus = 'plus',
  Plus2 = 'plus-2',
  Pinterest = 'pinterest',
  Phone = 'phone',
  PhoneInline = 'phone-inline',
  Notification = 'notification',
  Minus = 'minus',
  Menu = 'menu',
  Martingales = 'martingales',
  Longsleeve = 'longsleeve',
  Logout = 'logout',
  Lock = 'lock',
  Location = 'location',
  Linkedin = 'linkedin',
  Instagram = 'instagram',
  I = 'i',
  Hoodie = 'hoodie',
  Home = 'home',
  Helmet = 'helmet',
  Headcollars = 'headcollars',
  Grooming = 'grooming',
  Grid4 = 'grid-4',
  Grid3 = 'grid-3',
  Grid2 = 'grid-2',
  Grid1 = 'grid-1',
  Gloves = 'gloves',
  Gift = 'gift',
  FullArrow = 'full-arrow',
  Flyhood = 'flyhood',
  Faqs = 'faqs',
  Facebook = 'facebook',
  Email = 'email',
  Edit = 'edit',
  Earth = 'earth',
  Download = 'download',
  Delivery = 'delivery',
  CreditCards = 'credit-cards',
  Copy = 'copy',
  Contact = 'contact',
  ContactUs = 'contact-us',
  Coat = 'coat',
  Close = 'close',
  Clock = 'clock',
  Chevron2Right = 'chevron2-right',
  Chevron2Left = 'chevron2-left',
  Chevron = 'chevron',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  Chat = 'chat',
  Card = 'card',
  Call = 'call',
  Bridle = 'bridle',
  Basket = 'basket',
  BasketAdd = 'basket-add',
  ArrowUp = 'arrow-up',
  ArrowSimpleLeft = 'arrow-simple-left',
  ArrowRight = 'arrow-right',
  ArrowRightBold = 'arrow-right-bold',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  AddressBook = 'address-book',
  Account = 'account',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Zoom]: '61697',
  [Icons.ZoomOut]: '61698',
  [Icons.ZoomIn]: '61699',
  [Icons.Youtube]: '61700',
  [Icons.Wishlist]: '61701',
  [Icons.WishlistFill]: '61702',
  [Icons.Wings]: '61703',
  [Icons.Twitter]: '61704',
  [Icons.Tshirt]: '61705',
  [Icons.Trousers]: '61706',
  [Icons.Tick]: '61707',
  [Icons.SymbolList]: '61708',
  [Icons.Stockist]: '61709',
  [Icons.Star]: '61710',
  [Icons.StarEmpty]: '61711',
  [Icons.Shoes]: '61712',
  [Icons.Share]: '61713',
  [Icons.Share1]: '61714',
  [Icons.Search]: '61715',
  [Icons.Saddle]: '61716',
  [Icons.SaddlePad]: '61717',
  [Icons.Rugs]: '61718',
  [Icons.Return]: '61719',
  [Icons.RateHalf]: '61720',
  [Icons.RateFull]: '61721',
  [Icons.RateEmpty]: '61722',
  [Icons.Print]: '61723',
  [Icons.Plus]: '61724',
  [Icons.Plus2]: '61725',
  [Icons.Pinterest]: '61726',
  [Icons.Phone]: '61727',
  [Icons.PhoneInline]: '61728',
  [Icons.Notification]: '61729',
  [Icons.Minus]: '61730',
  [Icons.Menu]: '61731',
  [Icons.Martingales]: '61732',
  [Icons.Longsleeve]: '61733',
  [Icons.Logout]: '61734',
  [Icons.Lock]: '61735',
  [Icons.Location]: '61736',
  [Icons.Linkedin]: '61737',
  [Icons.Instagram]: '61738',
  [Icons.I]: '61739',
  [Icons.Hoodie]: '61740',
  [Icons.Home]: '61741',
  [Icons.Helmet]: '61742',
  [Icons.Headcollars]: '61743',
  [Icons.Grooming]: '61744',
  [Icons.Grid4]: '61745',
  [Icons.Grid3]: '61746',
  [Icons.Grid2]: '61747',
  [Icons.Grid1]: '61748',
  [Icons.Gloves]: '61749',
  [Icons.Gift]: '61750',
  [Icons.FullArrow]: '61751',
  [Icons.Flyhood]: '61752',
  [Icons.Faqs]: '61753',
  [Icons.Facebook]: '61754',
  [Icons.Email]: '61755',
  [Icons.Edit]: '61756',
  [Icons.Earth]: '61757',
  [Icons.Download]: '61758',
  [Icons.Delivery]: '61759',
  [Icons.CreditCards]: '61760',
  [Icons.Copy]: '61761',
  [Icons.Contact]: '61762',
  [Icons.ContactUs]: '61763',
  [Icons.Coat]: '61764',
  [Icons.Close]: '61765',
  [Icons.Clock]: '61766',
  [Icons.Chevron2Right]: '61767',
  [Icons.Chevron2Left]: '61768',
  [Icons.Chevron]: '61769',
  [Icons.ChevronRight]: '61770',
  [Icons.ChevronLeft]: '61771',
  [Icons.Chat]: '61772',
  [Icons.Card]: '61773',
  [Icons.Call]: '61774',
  [Icons.Bridle]: '61775',
  [Icons.Basket]: '61776',
  [Icons.BasketAdd]: '61777',
  [Icons.ArrowUp]: '61778',
  [Icons.ArrowSimpleLeft]: '61779',
  [Icons.ArrowRight]: '61780',
  [Icons.ArrowRightBold]: '61781',
  [Icons.ArrowLeft]: '61782',
  [Icons.ArrowDown]: '61783',
  [Icons.AddressBook]: '61784',
  [Icons.Account]: '61785',
};
